import { useState, useEffect, RefObject } from 'react';
import { scrollIntoViewIfNeeded } from 'utils/dom';

interface ScrollRequest {
  scrollLocationInBlockDirection?: 'start' | 'end';
}

const SCROLL_REQUEST_DEFAULTS = {};

/** A hook that allows you to request a scroll to a HTML element. The HTML element
 * needs to be provided as a ref. Call requestScroll when you need the scroll to
 * happen. The scroll will only occur if the element is not already in view
 */
export function useScrollToElement(ref: RefObject<HTMLElement>) {
  const [scrollRequested, setScrollRequested] = useState<
    ScrollRequest | undefined
  >(undefined);

  useEffect(() => {
    if (scrollRequested) {
      if (ref.current) {
        scrollIntoViewIfNeeded(
          ref.current,
          undefined,
          scrollRequested?.scrollLocationInBlockDirection,
        );
      } else {
        console.warn(
          'Attempted to scroll to an element, but the ref was falsey',
        );
      }
      setScrollRequested(undefined);
    }
  }, [ref, scrollRequested]);

  return {
    requestScroll: (args?: ScrollRequest) =>
      setScrollRequested(args || SCROLL_REQUEST_DEFAULTS),
  };
}
